import { tempStore } from "../stores/temp.store";

import { vratGeojsonData } from "../api/datalayer";
import { vratVrstvyMapyPodlaTypu } from "./config";
import { sourceExists, pridajVrstvy } from "./map";
import { get as get_store } from "svelte/store";
import get from "get-value";
import set from "set-value";

export const datalayer = async (map, layer) => {
  let sourceData = await vratGeojsonData(layer.url);
  const url = new URL(layer.url, location);
  const urlParams = new URLSearchParams(url.search);
  const interval = urlParams.get("int");
  let store = get_store(tempStore);
  const typ = layer.kod;
  // vytvorim si ID pre zdroj mapboxu. Musi to byt jedinecne
  const source_id = `datalayer_${typ}`;

  const vrstvy = vratVrstvyMapyPodlaTypu(typ);
  console.log(vrstvy, typ);
  if (vrstvy) {
    if (!sourceData || sourceExists(source_id) !== false) {
      return false;
    }
    map.addSource(`datalayer_${layer.kod}`, {
      type: "geojson",
      data: sourceData,
    });

    pridajVrstvy(typ, null, false, source_id);

    if (interval) {
      const int = setInterval(async () => {
        sourceData = await vratGeojsonData(layer.url);
        if (!sourceData || sourceExists(source_id) === false) {
          return false;
        }

        map.getSource(`datalayer_${layer.kod}`).setData(sourceData);
      }, 1000 * interval);

      set(store, `intervals.datalayer_${layer.kod}`, int);
      tempStore.set(store);
    }
  }
};

export const datalayersClear = (map, vrstvy) => {
  clearIntervals(vrstvy);
  removeLayers(map, vrstvy);
};

const clearIntervals = (vrstvy) => {
  let intervals = get(get_store(tempStore), "intervals", false);

  for (const interval in intervals) {
    if (vrstvy.find((o) => `datalayer_${o.kod}` === interval) === undefined) {
      clearInterval(intervals[interval]);
    }
  }
};

const removeLayers = (map, vrstvy) => {
  let intervals = get(get_store(tempStore), "intervals", false);
  let store = get_store(tempStore);
  for (const source_id in intervals) {
    if (vrstvy.find((o) => `datalayer_${o.kod}` === source_id) === undefined) {
      map
        .getStyle()
        .layers.filter((l) => l.source === source_id)
        .forEach((l) => map.removeLayer(l.id));

      if (sourceExists(source_id)) {
        map.removeSource(source_id);
      }
      delete store.intervals[source_id];
    }
  }
  tempStore.set(store);
};
